import { useEffect, useRef, useState } from "react";
import { isElementInViewport } from "../../utils/isElementInViewport";
import styles from "./LinearProgress.module.scss";

export const LinearProgress = (props) => {
  const el = useRef();
  const isEffectAdded = useRef(false);
  const [progressStyle, setProgressStyle] = useState("");
  const intervalRef = useRef();

  useEffect(() => {
    const timeout = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        checkVisibility();
      }, 250);
    }, 500);
    return () => {
      window.clearInterval(intervalRef.current);
      window.clearTimeout(timeout);
    };
  }, []);

  const checkVisibility = () => {
    if (!el || isEffectAdded.current) return;
    if (isElementInViewport(el.current)) {
      setProgressStyle(getProgressStyle());
      isEffectAdded.current = true;
      clearInterval(intervalRef.current);
    }
  };
  const getProgressStyle = () => {
    switch (parseInt(props.progress)) {
      case 95:
        return styles.progress95;
      case 90:
        return styles.progress90;
      case 85:
        return styles.progress85;
      case 80:
        return styles.progress80;
      case 75:
        return styles.progress75;
      case 70:
        return styles.progress70;
      case 65:
        return styles.progress65;
      case 60:
        return styles.progress60;
      case 55:
        return styles.progress55;
      case 50:
        return styles.progress50;
      default:
        return styles.progress0;
    }
  };
  return (
    <div className={styles.linearProgress} ref={el}>
      <div className={styles.texts}>
        <div className={styles.skill}>{props.text}</div>
        <div className={styles.progressText}>
          {props.progress}
          <div className={styles.smaller}>%</div>
        </div>
      </div>
      <div className={styles.progressContainer}>
        <div className={progressStyle}></div>
        <div className={styles.progressBg}></div>
      </div>
    </div>
  );
};
